import { render, staticRenderFns } from "./HeadBsnPlnList.vue?vue&type=template&id=4955bc2e&"
import script from "./HeadBsnPlnList.vue?vue&type=script&lang=js&"
export * from "./HeadBsnPlnList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports